import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import getPhoenixUrlParams from '../lib/get-phoenix-url-params'

import LoadingPage from './LoadingPage'
import useCartCreationHandler from './useCartCreationHandler'

const CartCreationHandler: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation()
  const history = useHistory()

  const { cartId, orderId } = getPhoenixUrlParams(location.search)

  if (location.pathname !== '/' || cartId || orderId) {
    return <>{children}</>
  }

  // here we actually are calling the react hook conditionally only because
  // in the case of the above condition, the hook itself will never be called
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { createdCartId } = useCartCreationHandler()

  if (createdCartId) {
    history.replace(`?cartId=${createdCartId}`)
  }

  return <LoadingPage />
}

export default CartCreationHandler
